;(function () {
  'use strict'

  angular
    .module('contrast.empty-state')
    .controller('csEmptyStateCtrl', [
      '$scope',
      'csEmptyStateConfig',
      csEmptyStateCtrl
    ])

  function csEmptyStateCtrl($scope, csEmptyStateConfig) {
    var vm = this
    var config

    this.$onInit = function () {
      activate()

      angular.extend(vm, {
        getIcon: getIcon,
        getIconSize: getIconSize,
        getPrimaryMsg: getPrimaryMsg,
        getSecondaryMsg: getSecondaryMsg,
        getExtraDetails: getExtraDetails
      })
    }

    $scope.$watch(function () {
      return vm.configKey
    }, activate)

    function activate() {
      if (
        angular.isString(vm.configKey) &&
        csEmptyStateConfig.has(vm.configKey)
      ) {
        config = csEmptyStateConfig.get(vm.configKey)
      } else {
        throw new Error('configKey invalid config')
      }
    }

    function getIcon() {
      return config.icon
    }

    function getIconSize() {
      return config.iconSize
    }

    function getPrimaryMsg() {
      return config.primaryMsg
    }

    function getSecondaryMsg() {
      return config.secondaryMsg
    }

    function getExtraDetails() {
      return config.extraDetails
    }
  }
})()
